// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"249c1eb6","447":"3c1dbf96","487":"02fa7f54","498":"6addbe94","626":"e9028bcb","670":"4d5d3cca","703":"f2c60403","740":"77a6d508"}[chunkId] + ".chunk.js";
};